export const TABLE_FEATURES = [
    'IPR',
    'Dental Monitoring',
    'Bite turbos/ramps',
    'Attachments',
    'Mandibular advancement'
];

export const INTENSITY_LABELS = [
    { value: 0, label: 'Never' },
    { value: 1, label: 'Rarely' },
    { value: 2, label: 'Sometimes' },
    { value: 3, label: 'Often' },
    { value: 4, label: 'Almost always' }
];

export const getRowClassName = (index: number, total: number, isSelected = false): string => {
    const isOdd = index % 2 === 1;
    const isLast = index === total - 1;
    const bgColor = isSelected ? 'bg-amber-50' : isOdd ? 'bg-gray-100' : 'bg-white';
    const border = isLast ? '' : 'border-b border-gray-200';
    return `${bgColor} ${border}`;
};

export const getYouTubeThumbnail = (url: string): string => {
    const PLACEHOLDER =
        'https://images.unsplash.com/photo-1599496336901-2b36a83637e6?q=80&w=2670&auto=format&fit=crop';
    try {
        const urlObj = new URL(url);
        if (urlObj.hostname === 'youtu.be' && urlObj.pathname) {
            return `https://img.youtube.com/vi/${urlObj.pathname.substring(1)}/0.jpg`;
        }
        const videoId = urlObj.searchParams.get('v');
        if (videoId) {
            return `https://img.youtube.com/vi/${videoId}/0.jpg`;
        }
    } catch {
        console.error('Invalid video URL:', url);
    }
    return PLACEHOLDER;
};
